module.exports = __webpack_public_path__ + "img/logo_dk_mark.6bb7bd6b.png";